import React, { useEffect, useState } from 'react';
import './Education.css'; 
import './homepage.css'// Import your CSS file for styling
import BottomBar from './BottomBar';
import CircularMenu from './CircularMenu';
import VideoModal from './VideoModal';


const Education = ({ educationData }) => {
  const [showModal, setShowModal] = useState(false);

const handleOpenModal = () => {
  setShowModal(true);
}

const handleCloseModal = () => {
  setShowModal(false);
}
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(document.querySelector('.timeline'));
  }, []);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = './resume.docx'; // Replace with your actual resume file path
    link.download = 'resume.docx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="homepagedark">
      <div className="bg1">
        <div className="bg-item"></div>
        <div className="line-group">
          {[...Array(6)].map((_, index) => (
            <div key={index} className="frame-child5"></div>
          ))}
        </div>
      </div>
      <div className="ololade-group">
        <div className="ololade2">
          <span>EDUCATION</span>
          <span className="span2">.</span>
        </div>
        </div>
        <div class="ololade-group">
        <div style={{ position: 'relative', minHeight: '100vh' }}>
  <div style={{
    position: 'absolute',
    top: 5,
    left: 680,
  }}>
    <button class="download-btndark" onClick={handleOpenModal}>
          <div class="download-btndark-child"></div>
          <div class="download-btndark-item"></div>
          <div class="resume1">Visume</div>
          <VideoModal 
        show={showModal} 
        handleClose={handleCloseModal} 
        videoSrc="" 
      />
          {/* <img
            class="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          /> */}
        </button>
  </div>
  <div style={{
    position: 'absolute',
    top: 5,
    left: 830,
  }}>
    <button class="download-btndark" onClick={handleDownload}>
          <div class="download-btndark-child"></div>
          <div class="download-btndark-item"></div>
          <div class="resume1">Resume</div>
          <img
            class="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          />
        </button>
  </div>
</div>
        
        
      </div>
        {/* <button className="download-btndark" onClick={handleDownload}>
          <div className="download-btndark-child"></div>
          <div className="download-btndark-item"></div>
          <div className="resume1">Resume</div>
          <img
            className="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg" // Replace with your actual download icon path
          />
        </button> 
        </div>*/}
      
      <div className="timeline">
        {educationData.map((item, index) => (
          <div key={index} className={`timeline-item ${isVisible ? 'show' : ''}`}>
            <div className="timeline-item-content">
              <span className="timeline-item-year">{item.year}</span>
              <h3 className="timeline-item-title">{item.title}</h3>
              <h4 className="timeline-item-institution">{item.grade}</h4>
              <h4 className="timeline-item-institution">{item.institution}</h4>
            </div>
          </div>
        ))}
      </div>
      {/* Include any additional components or footer */}
      <BottomBar />
      <div style={{ position: 'relative', minHeight: '100vh' }}>
  <div style={{
    position: 'absolute',
    bottom: 278,
    right: 50,
  }}>
    <CircularMenu />
  </div>
</div>
    </div>
  );
};

export default Education;
